export default __webpack_public_path__ + "static/Hello-pl_2-f074262c73cf938c8f7454ec298b022d.gif";